import script from "./ShipperContacts.vue?vue&type=script&setup=true&lang=js"
export * from "./ShipperContacts.vue?vue&type=script&setup=true&lang=js"

import "./ShipperContacts.vue?vue&type=style&index=0&id=7cf9bd7a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cf9bd7a"]])

export default __exports__